import { useEffect, useRef, useState } from 'react';
import { Pause, Play, RotateCcw } from 'lucide-react';
import type { OriginControls } from './originRuntime';

export function OriginScene() {
  const canvas = useRef<HTMLCanvasElement>(null);
  const controls = useRef<OriginControls | null>(null);
  const [paused, setPaused] = useState(() => matchMedia('(prefers-reduced-motion: reduce)').matches);
  const pausedRef = useRef(paused);
  pausedRef.current = paused;
  const [status, setStatus] = useState('loading');
  useEffect(() => {
    let active = true;
    void import('./originRuntime.js').then(({ mountOrigin }) => {
      if (!active || !canvas.current) return;
      try {
        controls.current = mountOrigin(canvas.current, ok => { if (active) setStatus(ok ? 'ready' : 'fallback'); });
        controls.current.setPaused(pausedRef.current);
      }
      catch { setStatus('fallback'); }
    }).catch(() => { if (active) setStatus('fallback'); });
    return () => { active=false;controls.current?.dispose();controls.current=null; };
  }, []);
  return <>
    <div className={`origin-stage origin-${status}`}><div className="origin-aura" />{status === 'fallback' && <img src="/brand/raydius-orb.png" alt="Raydius orbital sculpture" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain', pointerEvents: 'none' }} />}<canvas ref={canvas} aria-label="Interactive orbital sculpture. Drag to orbit the center." /><div className="origin-cross origin-cross-one">+</div><div className="origin-cross origin-cross-two">+</div></div>
    <div className="orbit-annotation"><span className="orbit-dot" /> <span className="orbit-sub">r = 1 · θ ∈ [0, 2π]</span></div>
    <div className="origin-controls"><span>{status === 'loading' ? 'Establishing orbit' : status === 'fallback' ? 'Still field' : 'Drag to orbit'}</span><button aria-pressed={paused} aria-label={paused ? 'Animate orbit' : 'Pause orbit'} onClick={() => { controls.current?.setPaused(!paused);setPaused(!paused); }}>{paused ? <Play size={13} /> : <Pause size={13} />}</button><button aria-label="Return scene to center" onClick={() => controls.current?.reset()}><RotateCcw size={13} /></button></div>
  </>;
}
